/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type EvaluatePortfolioBadRequestErrorCode =
  (typeof EvaluatePortfolioBadRequestErrorCode)[keyof typeof EvaluatePortfolioBadRequestErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EvaluatePortfolioBadRequestErrorCode = {
  questionnaire_not_evaluated: "questionnaire_not_evaluated",
  nsure_case_rejected: "nsure_case_rejected",
  nsure_self_dealing_forbidden: "nsure_self_dealing_forbidden",
} as const;
